<script setup lang="ts">
import {
  KollegeSakugenkahi,
  type KollegeExpenseItem,
} from '@/types/schema.generated'
import DailyLessonSakugenkahiLabel from './DailyLessonSakugenkahiLabel.vue'

const props = defineProps<{
  expense: KollegeExpenseItem
  title: string
}>()
</script>

<template>
  <div :class="$style.expense">
    <DailyLessonSakugenkahiLabel :sakugenkahi="props.expense?.sakugenkahi" />
    <div
      :class="[
        $style.expense__content,
        expense.sakugenkahi === KollegeSakugenkahi.SakugenFuka
          ? $style[`expense__content--sakugenFuka`]
          : null,
      ]"
    >
      <h3 :class="$style.expense__title">{{ title }}</h3>
      <p
        v-if="typeof props.expense.amount === 'number'"
        :class="$style.expense__amount"
      >
        {{ props.expense.amount }}円
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
.expense {
  display: flex;
  gap: 8px;
  justify-content: space-between;

  &__content {
    display: flex;
    gap: 4px;
    align-items: center;

    &--sakugenFuka {
      color: $color-text-and-object-accent-red;
    }
  }

  &__title {
    font-size: 14px;
    line-height: 1;
    font-weight: normal;
  }

  &__amount {
    font-size: 14px;
    line-height: 1;
    font-weight: bold;
  }
}
</style>
